import BaseView from "scripts/views/baseView";
import templateFacetedSearchQueryPill from "templates/search/facetedSearchQueryPill.hbs";

class FacetedSearchQueryPillView extends BaseView {
  constructor(options) {
    super(options);

    this.param = options.param;
    this.label = options.label;
    this.value = options.value;
    this.hasValues = options.hasValues;
  }

  get template() {
    return templateFacetedSearchQueryPill;
  }

  get className() {
    return "faceted-search-query-pill closable";
  }

  get events() {
    return {
      "click .faceted-search-query-pill-close-icon": "onClickClose",
      "click .faceted-search-query-pill-link": "onClickLink",
    };
  }

  render() {
    this.$el.html(
      this.template({
        label: this.label,
        value: this.value,
        hasValues: this.hasValues,
      }),
    );
  }

  onClickClose() {
    this.trigger("close", this.param);
  }

  onClickLink() {
    this.trigger("click", this.param);
  }

  setClosable(closable) {
    if (closable) {
      this.$el.addClass("closable");
    } else {
      this.$el.removeClass("closable");
    }
  }
}

export default FacetedSearchQueryPillView;
